import { render, staticRenderFns } from "./SorteioAuditoralNfse.vue?vue&type=template&id=cbbf981a&scoped=true&"
import script from "./SorteioAuditoralNfse.vue?vue&type=script&lang=js&"
export * from "./SorteioAuditoralNfse.vue?vue&type=script&lang=js&"
import style0 from "./SorteioAuditoralNfse.vue?vue&type=style&index=0&id=cbbf981a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbf981a",
  null
  
)

export default component.exports